import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: '1',
      name: i18n.t('tipos.recurrencia.mensual')
    },
    {
      id: '2',
      name: i18n.t('tipos.recurrencia.trimestral')
    },
    {
      id: '3',
      name: i18n.t('tipos.recurrencia.semestral')
    },
    {
      id: '4',
      name: i18n.t('tipos.recurrencia.anual')
    },
  ]
}

export function TIPOS_RECURRENCIA (state) {
  return configHelper.getConfig(state, 'TIPOS_RECURRENCIA', GenerateConfig)
}
